import apollo from '@/apollo.js'
import gql from 'graphql-tag'

const deleteTypeNames = (emailAccount) => {
  delete emailAccount.__typename
  delete emailAccount.imapDetails.__typename
  delete emailAccount.smtpDetails.__typename
}

export const createEmailAccount = async (emailAccount) => {
  deleteTypeNames(emailAccount)
  const variables = { 
    name: emailAccount.name, 
    description: emailAccount.description, 
    imapDetails: emailAccount.imapDetails, 
    smtpDetails: emailAccount.smtpDetails, 
    isDefault: !!emailAccount.isDefault,
    sendChannel: emailAccount.sendChannel,
    receiveChannel: emailAccount.receiveChannel
  }
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createEmailAccount($name: String!, $description: String!, $isDefault: Boolean!, $sendChannel: EmailConnector, $receiveChannel: EmailConnector, $imapDetails: IMAPInput, $smtpDetails: SMTPInput) {
        createEmailAccount(name: $name, description: $description, isDefault: $isDefault, sendChannel: $sendChannel, receiveChannel: $receiveChannel, imapDetails: $imapDetails, smtpDetails: $smtpDetails) {
          error
          message
          lowLevelErrorMessage
          
          emailAccount {
            id
            name
            description
            isDefault
            sendChannel
            receiveChannel
            serverMessage
            hasMessage
            mailgunDomain
            mailgunDomainState
            mailgunDnsRecords
            meta
            imapDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
            }
            smtpDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
              replyToEmailAddress
              useReplyToAsFrom
            }
          }
        }
      }`),
      variables
    })
  return response.data.createEmailAccount
}

export const updateEmailAccount = async (emailAccount) => {
  deleteTypeNames(emailAccount)
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateEmailAccount($id: Int!, $name: String!, $description: String!, $isDefault: Boolean!, $sendChannel: EmailConnector, $receiveChannel: EmailConnector, $imapDetails: IMAPInput, $smtpDetails: SMTPInput) {
        updateEmailAccount(id: $id, name: $name, description: $description, isDefault: $isDefault, sendChannel: $sendChannel, receiveChannel: $receiveChannel, imapDetails: $imapDetails, smtpDetails: $smtpDetails) {
          error
          message
          lowLevelErrorMessage
          
          emailAccount {
            id
            name
            description
            isDefault
            sendChannel
            receiveChannel
            serverMessage
            hasMessage
            mailgunDomain
            mailgunDomainState
            mailgunDnsRecords
            meta
            imapDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
            }
            smtpDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
              replyToEmailAddress
              useReplyToAsFrom
            }
          }
        }
      }`),
      variables: { 
        id: parseInt(emailAccount.id, 10), 
        name: emailAccount.name, 
        description: emailAccount.description, 
        imapDetails: emailAccount.imapDetails, 
        smtpDetails: emailAccount.smtpDetails, 
        isDefault: !!emailAccount.isDefault,
        sendChannel: emailAccount.sendChannel,
        receiveChannel: emailAccount.receiveChannel
      }
    })
  return response.data.updateEmailAccount
}

export const deleteEmailAccount = async (emailAccount) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteEmailAccount($id: Int!) {
        deleteEmailAccount(id: $id) {
          error
          message
          lowLevelErrorMessage
        }
      }`),
      variables: { id: parseInt(emailAccount.id, 10) }
    })
  return response.data.deleteEmailAccount
}

export const setupMailgunDomain = async ({ emailAccountId, domain }) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation setupMailgunDomain($emailAccountId: Int!, $domain: String) {
        setupMailgunDomain(emailAccountId: $emailAccountId, domain: $domain) {
          error
          message
          lowLevelErrorMessage
          emailAccount {
            id
            name
            description
            isDefault
            sendChannel
            receiveChannel
            serverMessage
            hasMessage
            mailgunDomain
            mailgunDomainState
            mailgunDnsRecords
            meta
            imapDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
            }
            smtpDetails {
              host
              port
              login
              password
              ssl
              startTLS
              enabled
              replyToEmailAddress
              useReplyToAsFrom
            }
          }
        }
      }
    `),
    variables: {
      emailAccountId: parseInt(emailAccountId, 10),
      domain: domain || null
    }
  })
  return response.data.setupMailgunDomain
}
